module.exports = __webpack_public_path__ + "static/img/icon_message.26ff204.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_message.jpg
// module id = 556
// module chunks = 1 7 8